import { render, staticRenderFns } from "./LiveIcon.vue?vue&type=template&id=78dcc564&scoped=true&"
import script from "./LiveIcon.vue?vue&type=script&lang=js&"
export * from "./LiveIcon.vue?vue&type=script&lang=js&"
import style0 from "./LiveIcon.vue?vue&type=style&index=0&id=78dcc564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dcc564",
  null
  
)

export default component.exports